import styled from "styled-components"

export const UpdateGoalWrapper = styled.div`
  font-size: 16px;
  line-height: 1.5;
  height: 100%;

  --header-height: 44px;

  background: var(--color-app-dark-linear-background);
  color: var(--color-white);
`

export const UpdateGoalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: var(--header-height);
  padding: 0 20px;
`
export const HeaderBackButton = styled.div`
  display: flex;
  position: absolute;
  left: 18px;
`

export const HeaderBackButtonInner = styled.div<{$isDisabled?: boolean}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  justify-content: center;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
`

export const UpdateGoalContent = styled.div`
  margin-bottom: auto;
  height: calc(100% - var(--header-height) - var(--app-cta-height));
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 var(--app-horizontal-padding);
  padding-top: 12px;
`
